/******************************************************************************\
 * :$
 *
 * Copyright(c) 2022 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: ErrorBoundary
 *
 * Purpose: error boundry for errors from app.  This is odne with React.Component because that is the only
 *          way it works.
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 10Jun2022 craig File created.
 \******************************************************************************/
import React, {ReactNode} from "react";
interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
}

export class ErrorBoundary extends React.Component<Props, State> {

    constructor(props:any) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError(error:any) : State {
        return {hasError : true};
    }

    componentDidCatch(error:Error, info:React.ErrorInfo) {
        this.logErrorToServices(error.toString(), info.componentStack);
    }

    // A fake logging service.
    logErrorToServices = console.log;

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <h1>Something went wrong.</h1>;
        }
        return this.props.children;
    }
}